import MainLayout from "@/layouts/MainLayout"
import ProjectBook from "@/pages/Project/Assets/ProjectBook"
import ChemicalComponentList from "@/pages/Project/Setting/Components"
import ProjectTask from "@/pages/Project/Task"
import ProjectTaskDetail from "@/pages/Project/Task/Detail"
import ProjectTaskGantt from "@/pages/Project/Task/Gantt"
import ProjectTaskList from "@/pages/Project/Task/List"
import { ComponentList } from "@/pages/Project/Workspace/ComponentList"
import { FlowFiles } from "@/pages/Project/Workspace/FlowFiles"
import { FluidPackages } from "@/pages/Project/Workspace/FluidPackages"
import UnitSetItem from "@/pages/UnitSet/Item"
import UnitSetList from "@/pages/UnitSet/List"
import ProjectFiles from '@/pages/Project/Assets/Files'
import ProjectDashboard from '@/pages/Project/Dashboard'
import ProjectMemberIndex from '@/pages/Project/Members'
import ProjectFailedInvitations from '@/pages/Project/Members/FailedInvitations'
import ProjectMembers from '@/pages/Project/Members/Members'
import ProjectOutsideCollaborators from '@/pages/Project/Members/OutsideCollaborators'
import ProjectPendingInvitations from '@/pages/Project/Members/PendingInvitations'
import ProjectSetting from '@/pages/Project/Setting'
import ProjectSettingRole from '@/pages/Project/Setting/Role'
import ProjectWorkspace from '@/pages/Project/Workspace'
import { Navigate, Outlet } from "react-router"
import { FlowSheetPage } from "@/pages/Project/Flowsheet/Flowsheet"
import { ProjectCases } from "@/pages/Project/Setting/Cases"
import { ProjectPropertySets } from "@/pages/Project/Setting/PropertySets/PropertySets"
import { MaterialBalance } from "@/pages/Project/MaterialBalance/MaterialBalance"
import { OPermissionAndElse } from "@/components/OPermission/OPermission"
import { ROLE_GENERAL } from "@/components/OPermission/PlanPermission"

export const projectRoutes = [
  {
    path: 'main/projects/:projectId',
    element: <OPermissionAndElse
      elseElem={<Navigate to='/404' />}
      permissions={ROLE_GENERAL}>
        <MainLayout />
    </OPermissionAndElse>,
    children: [
      {
        path: '',
        element: <Navigate to='workspace' />
      },
      {
        path: 'workspace',
        element: <ProjectWorkspace />,
        children: [
          {
            path: '',
            element: <Navigate to='component-list' />
          },
          {
            path: 'component-list',
            element: <ComponentList />
          },
          {
            path: 'fluid-packages',
            element: <FluidPackages />
          },
          {
            path: 'flow-files',
            element: <FlowFiles />
          },
        ]
      },
      {
        path: 'dashboard',
        element: <ProjectDashboard />
      },
      {
        path: 'tasks',
        element: <ProjectTask />,
        children: [
          {
            path: '',
            element: <Navigate to='list' />
          },
          {
            path: 'list',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <ProjectTaskList />
              },
              {
                path: ':id',
                element: <ProjectTaskDetail />
              }
            ]
          },
          {
            path: 'gantt',
            element: <ProjectTaskGantt />
          }
        ]
      },
      {
        path: '',
        element: <ProjectMemberIndex />,
        children: [
          {
            path: 'members',
            element: <ProjectMembers />
          },
          {
            path: 'outside-collaborators',
            element: <ProjectOutsideCollaborators />
          },
          {
            path: 'pending-invitations',
            element: <ProjectPendingInvitations />
          },
          {
            path: 'failed-invitations',
            element: <ProjectFailedInvitations />
          }
        ]
      },
      {
        path: 'assets',
        element: <Outlet />,
        children: [
          { path: '', element: <Navigate to='files' /> },
          { path: 'files', element: <ProjectFiles /> },
          { path: 'book', element: <ProjectBook /> }
        ]
      },
      {
        path: 'setting',
        element: <ProjectSetting />,
        children: [
          {
            path: '',
            element: <Navigate to='cases' />
          },
          {
            path: 'cases',
            element: <ProjectCases />
          },
          {
            path: 'property-sets',
            element: <ProjectPropertySets />
          },
          {
            path: 'role',
            element: <ProjectSettingRole />
          },
          {
            path: 'components',
            element: <ChemicalComponentList />
          },
          {
            path: 'unit-set',
            element: <Outlet />,
            children: [
              { path: '', element: <UnitSetList /> },
              { path: 'create', element: <UnitSetItem /> },
              { path: ':id', element: <UnitSetItem /> }
            ]
          },
        ]
      }
    ]
  },
  {
    path: 'main/projects/:projectId/flows/:id',
    element: <OPermissionAndElse
      elseElem={<Navigate to='/404' />}
      permissions={ROLE_GENERAL}>
        <FlowSheetPage />
    </OPermissionAndElse>,
  },
  {
    path: 'main/projects/:projectId/templates/:id',
    element: <OPermissionAndElse
      elseElem={<Navigate to='/404' />}
      permissions={ROLE_GENERAL}>
        <FlowSheetPage />
    </OPermissionAndElse>,
  },
  {
    path: 'main/projects/:projectId/mb/:id',
    element: <OPermissionAndElse
      elseElem={<Navigate to='/404' />}
      permissions={ROLE_GENERAL}>
        <MaterialBalance />
    </OPermissionAndElse>,
  },
]